import c from "@emotion/css";
import { createContext as g, forwardRef as e, createElement as b, useRef as I, useCallback as l } from "react";
import t from "@emotion/is-prop-valid";
import { Manager as i, Reference as n, Popper as C } from "react-popper";
import { useDebouncedCallback as o } from "use-debounce";
import { themes as r } from "@quid/theme";
import A from "color";
import G from "@quid/react-mouse-outside";
import u from "@quid/merge-refs";
import a from "@quid/react-use-controlled-state";

function Z() {
  return (Z = Object.assign || function (c) {
    for (var g = 1; g < arguments.length; g++) {
      var e = arguments[g];

      for (var b in e) {
        Object.prototype.hasOwnProperty.call(e, b) && (c[b] = e[b]);
      }
    }

    return c;
  }).apply(this, arguments);
}

var s = function s(c, g, e) {
  return g in c ? Object.defineProperty(c, g, {
    value: e,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : c[g] = e, c;
},
    m = function () {
  function c(c) {
    this.isSpeedy = void 0 === c.speedy ? "production" === process.env.NODE_ENV : c.speedy, this.tags = [], this.ctr = 0, this.nonce = c.nonce, this.key = c.key, this.container = c.container, this.before = null;
  }

  var g = c.prototype;
  return g.insert = function (c) {
    if (this.ctr % (this.isSpeedy ? 65e3 : 1) == 0) {
      var g = function (c) {
        var g = document.createElement("style");
        return g.setAttribute("data-emotion", c.key), void 0 !== c.nonce && g.setAttribute("nonce", c.nonce), g.appendChild(document.createTextNode("")), g;
      }(this);

      this.container.insertBefore(g, 0 === this.tags.length ? this.before : this.tags[this.tags.length - 1].nextSibling), this.tags.push(g);
    }

    var e = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var b = function (c) {
        if (c.sheet) return c.sheet;

        for (var g = 0; g < document.styleSheets.length; g++) {
          if (document.styleSheets[g].ownerNode === c) return document.styleSheets[g];
        }
      }(e);

      try {
        var I = 105 === c.charCodeAt(1) && 64 === c.charCodeAt(0);
        b.insertRule(c, I ? 0 : b.cssRules.length);
      } catch (g) {
        "production" !== process.env.NODE_ENV && console.warn('There was a problem inserting the following rule: "' + c + '"', g);
      }
    } else e.appendChild(document.createTextNode(c));

    this.ctr++;
  }, g.flush = function () {
    this.tags.forEach(function (c) {
      return c.parentNode.removeChild(c);
    }), this.tags = [], this.ctr = 0;
  }, c;
}();

function d(c) {
  function g(c, g, b) {
    var I = g.trim().split(u);
    g = I;
    var l = I.length,
        t = c.length;

    switch (t) {
      case 0:
      case 1:
        var i = 0;

        for (c = 0 === t ? "" : c[0] + " "; i < l; ++i) {
          g[i] = e(c, g[i], b).trim();
        }

        break;

      default:
        var n = i = 0;

        for (g = []; i < l; ++i) {
          for (var C = 0; C < t; ++C) {
            g[n++] = e(c[C] + " ", I[i], b).trim();
          }
        }

    }

    return g;
  }

  function e(c, g, e) {
    var b = g.charCodeAt(0);

    switch (33 > b && (b = (g = g.trim()).charCodeAt(0)), b) {
      case 38:
        return g.replace(a, "$1" + c.trim());

      case 58:
        return c.trim() + g.replace(a, "$1" + c.trim());

      default:
        if (0 < 1 * e && 0 < g.indexOf("\f")) return g.replace(a, (58 === c.charCodeAt(0) ? "" : "$1") + c.trim());
    }

    return c + g;
  }

  function b(c, g, e, l) {
    var t = c + ";",
        i = 2 * g + 3 * e + 4 * l;

    if (944 === i) {
      c = t.indexOf(":", 9) + 1;
      var n = t.substring(c, t.length - 1).trim();
      return n = t.substring(0, c).trim() + n + ";", 1 === J || 2 === J && I(n, 1) ? "-webkit-" + n + n : n;
    }

    if (0 === J || 2 === J && !I(t, 1)) return t;

    switch (i) {
      case 1015:
        return 97 === t.charCodeAt(10) ? "-webkit-" + t + t : t;

      case 951:
        return 116 === t.charCodeAt(3) ? "-webkit-" + t + t : t;

      case 963:
        return 110 === t.charCodeAt(5) ? "-webkit-" + t + t : t;

      case 1009:
        if (100 !== t.charCodeAt(4)) break;

      case 969:
      case 942:
        return "-webkit-" + t + t;

      case 978:
        return "-webkit-" + t + "-moz-" + t + t;

      case 1019:
      case 983:
        return "-webkit-" + t + "-moz-" + t + "-ms-" + t + t;

      case 883:
        if (45 === t.charCodeAt(8)) return "-webkit-" + t + t;
        if (0 < t.indexOf("image-set(", 11)) return t.replace(x, "$1-webkit-$2") + t;
        break;

      case 932:
        if (45 === t.charCodeAt(4)) switch (t.charCodeAt(5)) {
          case 103:
            return "-webkit-box-" + t.replace("-grow", "") + "-webkit-" + t + "-ms-" + t.replace("grow", "positive") + t;

          case 115:
            return "-webkit-" + t + "-ms-" + t.replace("shrink", "negative") + t;

          case 98:
            return "-webkit-" + t + "-ms-" + t.replace("basis", "preferred-size") + t;
        }
        return "-webkit-" + t + "-ms-" + t + t;

      case 964:
        return "-webkit-" + t + "-ms-flex-" + t + t;

      case 1023:
        if (99 !== t.charCodeAt(8)) break;
        return "-webkit-box-pack" + (n = t.substring(t.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify")) + "-webkit-" + t + "-ms-flex-pack" + n + t;

      case 1005:
        return A.test(t) ? t.replace(r, ":-webkit-") + t.replace(r, ":-moz-") + t : t;

      case 1e3:
        switch (g = (n = t.substring(13).trim()).indexOf("-") + 1, n.charCodeAt(0) + n.charCodeAt(g)) {
          case 226:
            n = t.replace(d, "tb");
            break;

          case 232:
            n = t.replace(d, "tb-rl");
            break;

          case 220:
            n = t.replace(d, "lr");
            break;

          default:
            return t;
        }

        return "-webkit-" + t + "-ms-" + n + t;

      case 1017:
        if (-1 === t.indexOf("sticky", 9)) break;

      case 975:
        switch (g = (t = c).length - 10, i = (n = (33 === t.charCodeAt(g) ? t.substring(0, g) : t).substring(c.indexOf(":", 7) + 1).trim()).charCodeAt(0) + (0 | n.charCodeAt(7))) {
          case 203:
            if (111 > n.charCodeAt(8)) break;

          case 115:
            t = t.replace(n, "-webkit-" + n) + ";" + t;
            break;

          case 207:
          case 102:
            t = t.replace(n, "-webkit-" + (102 < i ? "inline-" : "") + "box") + ";" + t.replace(n, "-webkit-" + n) + ";" + t.replace(n, "-ms-" + n + "box") + ";" + t;
        }

        return t + ";";

      case 938:
        if (45 === t.charCodeAt(5)) switch (t.charCodeAt(6)) {
          case 105:
            return n = t.replace("-items", ""), "-webkit-" + t + "-webkit-box-" + n + "-ms-flex-" + n + t;

          case 115:
            return "-webkit-" + t + "-ms-flex-item-" + t.replace(V, "") + t;

          default:
            return "-webkit-" + t + "-ms-flex-line-pack" + t.replace("align-content", "").replace(V, "") + t;
        }
        break;

      case 973:
      case 989:
        if (45 !== t.charCodeAt(3) || 122 === t.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === y.test(c)) return 115 === (n = c.substring(c.indexOf(":") + 1)).charCodeAt(0) ? b(c.replace("stretch", "fill-available"), g, e, l).replace(":fill-available", ":stretch") : t.replace(n, "-webkit-" + n) + t.replace(n, "-moz-" + n.replace("fill-", "")) + t;
        break;

      case 962:
        if (t = "-webkit-" + t + (102 === t.charCodeAt(5) ? "-ms-" + t : "") + t, 211 === e + l && 105 === t.charCodeAt(13) && 0 < t.indexOf("transform", 10)) return t.substring(0, t.indexOf(";", 27) + 1).replace(G, "$1-webkit-$2") + t;
    }

    return t;
  }

  function I(c, g) {
    var e = c.indexOf(1 === g ? ":" : "{"),
        b = c.substring(0, 3 !== g ? e : 10);
    return e = c.substring(e + 1, c.length - 1), N(2 !== g ? b : b.replace(v, "$1"), e, g);
  }

  function l(c, g) {
    var e = b(g, g.charCodeAt(0), g.charCodeAt(1), g.charCodeAt(2));
    return e !== g + ";" ? e.replace(W, " or ($1)").substring(4) : "(" + g + ")";
  }

  function t(c, g, e, b, I, l, t, i, C, o) {
    for (var r, A = 0, G = g; A < H; ++A) {
      switch (r = Y[A].call(n, c, G, e, b, I, l, t, i, C, o)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          G = r;
      }
    }

    if (G !== g) return G;
  }

  function i(c) {
    return void 0 !== (c = c.prefix) && (N = null, c ? "function" != typeof c ? J = 1 : (J = 2, N = c) : J = 0), i;
  }

  function n(c, e) {
    var i = c;

    if (33 > i.charCodeAt(0) && (i = i.trim()), i = [i], 0 < H) {
      var n = t(-1, e, i, i, p, X, 0, 0, 0, 0);
      void 0 !== n && "string" == typeof n && (e = n);
    }

    var r = function c(e, i, n, r, A) {
      for (var G, u, a, d, W, V = 0, v = 0, y = 0, x = 0, Y = 0, N = 0, R = a = G = 0, k = 0, F = 0, z = 0, L = 0, S = n.length, j = S - 1, D = "", Q = "", O = "", U = ""; k < S;) {
        if (u = n.charCodeAt(k), k === j && 0 !== v + x + y + V && (0 !== v && (u = 47 === v ? 10 : 47), x = y = V = 0, S++, j++), 0 === v + x + y + V) {
          if (k === j && (0 < F && (D = D.replace(o, "")), 0 < D.trim().length)) {
            switch (u) {
              case 32:
              case 9:
              case 59:
              case 13:
              case 10:
                break;

              default:
                D += n.charAt(k);
            }

            u = 59;
          }

          switch (u) {
            case 123:
              for (G = (D = D.trim()).charCodeAt(0), a = 1, L = ++k; k < S;) {
                switch (u = n.charCodeAt(k)) {
                  case 123:
                    a++;
                    break;

                  case 125:
                    a--;
                    break;

                  case 47:
                    switch (u = n.charCodeAt(k + 1)) {
                      case 42:
                      case 47:
                        c: {
                          for (R = k + 1; R < j; ++R) {
                            switch (n.charCodeAt(R)) {
                              case 47:
                                if (42 === u && 42 === n.charCodeAt(R - 1) && k + 2 !== R) {
                                  k = R + 1;
                                  break c;
                                }

                                break;

                              case 10:
                                if (47 === u) {
                                  k = R + 1;
                                  break c;
                                }

                            }
                          }

                          k = R;
                        }

                    }

                    break;

                  case 91:
                    u++;

                  case 40:
                    u++;

                  case 34:
                  case 39:
                    for (; k++ < j && n.charCodeAt(k) !== u;) {
                      ;
                    }

                }

                if (0 === a) break;
                k++;
              }

              switch (a = n.substring(L, k), 0 === G && (G = (D = D.replace(C, "").trim()).charCodeAt(0)), G) {
                case 64:
                  switch (0 < F && (D = D.replace(o, "")), u = D.charCodeAt(1)) {
                    case 100:
                    case 109:
                    case 115:
                    case 45:
                      F = i;
                      break;

                    default:
                      F = w;
                  }

                  if (L = (a = c(i, F, a, u, A + 1)).length, 0 < H && (W = t(3, a, F = g(w, D, z), i, p, X, L, u, A, r), D = F.join(""), void 0 !== W && 0 === (L = (a = W.trim()).length) && (u = 0, a = "")), 0 < L) switch (u) {
                    case 115:
                      D = D.replace(B, l);

                    case 100:
                    case 109:
                    case 45:
                      a = D + "{" + a + "}";
                      break;

                    case 107:
                      a = (D = D.replace(Z, "$1 $2")) + "{" + a + "}", a = 1 === J || 2 === J && I("@" + a, 3) ? "@-webkit-" + a + "@" + a : "@" + a;
                      break;

                    default:
                      a = D + a, 112 === r && (Q += a, a = "");
                  } else a = "";
                  break;

                default:
                  a = c(i, g(i, D, z), a, r, A + 1);
              }

              O += a, a = z = F = R = G = 0, D = "", u = n.charCodeAt(++k);
              break;

            case 125:
            case 59:
              if (1 < (L = (D = (0 < F ? D.replace(o, "") : D).trim()).length)) switch (0 === R && (G = D.charCodeAt(0), 45 === G || 96 < G && 123 > G) && (L = (D = D.replace(" ", ":")).length), 0 < H && void 0 !== (W = t(1, D, i, e, p, X, Q.length, r, A, r)) && 0 === (L = (D = W.trim()).length) && (D = "\0\0"), G = D.charCodeAt(0), u = D.charCodeAt(1), G) {
                case 0:
                  break;

                case 64:
                  if (105 === u || 99 === u) {
                    U += D + n.charAt(k);
                    break;
                  }

                default:
                  58 !== D.charCodeAt(L - 1) && (Q += b(D, G, u, D.charCodeAt(2)));
              }
              z = F = R = G = 0, D = "", u = n.charCodeAt(++k);
          }
        }

        switch (u) {
          case 13:
          case 10:
            47 === v ? v = 0 : 0 === 1 + G && 107 !== r && 0 < D.length && (F = 1, D += "\0"), 0 < H * f && t(0, D, i, e, p, X, Q.length, r, A, r), X = 1, p++;
            break;

          case 59:
          case 125:
            if (0 === v + x + y + V) {
              X++;
              break;
            }

          default:
            switch (X++, d = n.charAt(k), u) {
              case 9:
              case 32:
                if (0 === x + V + v) switch (Y) {
                  case 44:
                  case 58:
                  case 9:
                  case 32:
                    d = "";
                    break;

                  default:
                    32 !== u && (d = " ");
                }
                break;

              case 0:
                d = "\\0";
                break;

              case 12:
                d = "\\f";
                break;

              case 11:
                d = "\\v";
                break;

              case 38:
                0 === x + v + V && (F = z = 1, d = "\f" + d);
                break;

              case 108:
                if (0 === x + v + V + h && 0 < R) switch (k - R) {
                  case 2:
                    112 === Y && 58 === n.charCodeAt(k - 3) && (h = Y);

                  case 8:
                    111 === N && (h = N);
                }
                break;

              case 58:
                0 === x + v + V && (R = k);
                break;

              case 44:
                0 === v + y + x + V && (F = 1, d += "\r");
                break;

              case 34:
              case 39:
                0 === v && (x = x === u ? 0 : 0 === x ? u : x);
                break;

              case 91:
                0 === x + v + y && V++;
                break;

              case 93:
                0 === x + v + y && V--;
                break;

              case 41:
                0 === x + v + V && y--;
                break;

              case 40:
                if (0 === x + v + V) {
                  if (0 === G) switch (2 * Y + 3 * N) {
                    case 533:
                      break;

                    default:
                      G = 1;
                  }
                  y++;
                }

                break;

              case 64:
                0 === v + y + x + V + R + a && (a = 1);
                break;

              case 42:
              case 47:
                if (!(0 < x + V + y)) switch (v) {
                  case 0:
                    switch (2 * u + 3 * n.charCodeAt(k + 1)) {
                      case 235:
                        v = 47;
                        break;

                      case 220:
                        L = k, v = 42;
                    }

                    break;

                  case 42:
                    47 === u && 42 === Y && L + 2 !== k && (33 === n.charCodeAt(L + 2) && (Q += n.substring(L, k + 1)), d = "", v = 0);
                }
            }

            0 === v && (D += d);
        }

        N = Y, Y = u, k++;
      }

      if (0 < (L = Q.length)) {
        if (F = i, 0 < H && void 0 !== (W = t(2, Q, F, e, p, X, L, r, A, r)) && 0 === (Q = W).length) return U + Q + O;

        if (Q = F.join(",") + "{" + Q + "}", 0 != J * h) {
          switch (2 !== J || I(Q, 2) || (h = 0), h) {
            case 111:
              Q = Q.replace(m, ":-moz-$1") + Q;
              break;

            case 112:
              Q = Q.replace(s, "::-webkit-input-$1") + Q.replace(s, "::-moz-$1") + Q.replace(s, ":-ms-input-$1") + Q;
          }

          h = 0;
        }
      }

      return U + Q + O;
    }(w, i, e, 0, 0);

    return 0 < H && void 0 !== (n = t(-2, r, i, i, p, X, r.length, 0, 0, 0)) && (r = n), h = 0, X = p = 1, r;
  }

  var C = /^\0+/g,
      o = /[\0\r\f]/g,
      r = /: */g,
      A = /zoo|gra/,
      G = /([,: ])(transform)/g,
      u = /,\r+?/g,
      a = /([\t\r\n ])*\f?&/g,
      Z = /@(k\w+)\s*(\S*)\s*/,
      s = /::(place)/g,
      m = /:(read-only)/g,
      d = /[svh]\w+-[tblr]{2}/,
      B = /\(\s*(.*)\s*\)/g,
      W = /([\s\S]*?);/g,
      V = /-self|flex-/g,
      v = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      y = /stretch|:\s*\w+\-(?:conte|avail)/,
      x = /([^-])(image-set\()/,
      X = 1,
      p = 1,
      h = 0,
      J = 1,
      w = [],
      Y = [],
      H = 0,
      N = null,
      f = 0;
  return n.use = function c(g) {
    switch (g) {
      case void 0:
      case null:
        H = Y.length = 0;
        break;

      default:
        if ("function" == typeof g) Y[H++] = g;else if ("object" == typeof g) for (var e = 0, b = g.length; e < b; ++e) {
          c(g[e]);
        } else f = 0 | !!g;
    }

    return c;
  }, n.set = i, void 0 !== c && i(c), n;
}

function B(c) {
  c && W.current.insert(c + "}");
}

var W = {
  current: null
},
    V = function V(c, g, e, b, I, l, t, i, n, C) {
  switch (c) {
    case 1:
      switch (g.charCodeAt(0)) {
        case 64:
          return W.current.insert(g + ";"), "";

        case 108:
          if (98 === g.charCodeAt(2)) return "";
      }

      break;

    case 2:
      if (0 === i) return g + "/*|*/";
      break;

    case 3:
      switch (i) {
        case 102:
        case 112:
          return W.current.insert(e[0] + g), "";

        default:
          return g + (0 === C ? "/*|*/" : "");
      }

    case -2:
      g.split("/*|*/}").forEach(B);
  }
};

function v(c, g, e) {
  var b = "";
  return e.split(" ").forEach(function (e) {
    void 0 !== c[e] ? g.push(c[e]) : b += e + " ";
  }), b;
}

var y,
    x,
    X = function X(c, g, e) {
  var b = c.key + "-" + g.name;

  if (!1 === e && void 0 === c.registered[b] && (c.registered[b] = g.styles), void 0 === c.inserted[g.name]) {
    var I = g;

    do {
      c.insert("." + b, I, c.sheet, !0), I = I.next;
    } while (void 0 !== I);
  }
},
    p = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
},
    h = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences",
    J = /[A-Z]|^ms/g,
    w = /_EMO_([^_]+?)_([^]*?)_EMO_/g,
    Y = function Y(c) {
  return 45 === c.charCodeAt(1);
},
    H = (y = function y(c) {
  return Y(c) ? c : c.replace(J, "-$&").toLowerCase();
}, x = {}, function (c) {
  return void 0 === x[c] && (x[c] = y(c)), x[c];
}),
    N = function N(c, g) {
  if (null == g || "boolean" == typeof g) return "";

  switch (c) {
    case "animation":
    case "animationName":
      if ("string" == typeof g) return g.replace(w, function (c, g, e) {
        return Q = {
          name: g,
          styles: e,
          next: Q
        }, g;
      });
  }

  return 1 === p[c] || Y(c) || "number" != typeof g || 0 === g ? g : g + "px";
};

if ("production" !== process.env.NODE_ENV) {
  var f = /(attr|calc|counters?|url)\(/,
      R = ["normal", "none", "counter", "open-quote", "close-quote", "no-open-quote", "no-close-quote", "initial", "inherit", "unset"],
      k = N,
      F = /^-ms-/,
      z = /-(.)/g,
      L = {};

  N = function N(c, g) {
    "content" === c && ("string" != typeof g || -1 === R.indexOf(g) && !f.test(g) && (g.charAt(0) !== g.charAt(g.length - 1) || '"' !== g.charAt(0) && "'" !== g.charAt(0))) && console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + g + "\"'`");
    var e = k(c, g);
    return "" === e || Y(c) || -1 === c.indexOf("-") || void 0 !== L[c] || (L[c] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + c.replace(F, "ms-").replace(z, function (c, g) {
      return g.toUpperCase();
    }) + "?")), e;
  };
}

var S = !0;

function j(c, g, e, b) {
  if (null == e) return "";

  if (void 0 !== e.__emotion_styles) {
    if ("production" !== process.env.NODE_ENV && "NO_COMPONENT_SELECTOR" === e.toString()) throw new Error("Component selectors can only be used in conjunction with babel-plugin-emotion.");
    return e;
  }

  switch (typeof e) {
    case "boolean":
      return "";

    case "object":
      if (1 === e.anim) return Q = {
        name: e.name,
        styles: e.styles,
        next: Q
      }, e.name;

      if (void 0 !== e.styles) {
        var I = e.next;
        if (void 0 !== I) for (; void 0 !== I;) {
          Q = {
            name: I.name,
            styles: I.styles,
            next: Q
          }, I = I.next;
        }
        var l = e.styles;
        return "production" !== process.env.NODE_ENV && void 0 !== e.map && (l += e.map), l;
      }

      return function (c, g, e) {
        var b = "";
        if (Array.isArray(e)) for (var I = 0; I < e.length; I++) {
          b += j(c, g, e[I], !1);
        } else for (var l in e) {
          var t = e[l];
          if ("object" != typeof t) b += null != g && void 0 !== g[t] ? l + "{" + g[t] + "}" : H(l) + ":" + N(l, t) + ";";else {
            if ("NO_COMPONENT_SELECTOR" === l && "production" !== process.env.NODE_ENV) throw new Error("Component selectors can only be used in conjunction with babel-plugin-emotion.");

            if (!Array.isArray(t) || "string" != typeof t[0] || null != g && void 0 !== g[t[0]]) {
              var i = j(c, g, t, !1);

              switch (l) {
                case "animation":
                case "animationName":
                  b += H(l) + ":" + i + ";";
                  break;

                default:
                  b += l + "{" + i + "}";
              }
            } else for (var n = 0; n < t.length; n++) {
              b += H(l) + ":" + N(l, t[n]) + ";";
            }
          }
        }
        return b;
      }(c, g, e);

    case "function":
      if (void 0 !== c) {
        var t = Q,
            i = e(c);
        return Q = t, j(c, g, i, b);
      }

      "production" !== process.env.NODE_ENV && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");

    default:
      if (null == g) return e;
      var n = g[e];
      return "production" !== process.env.NODE_ENV && b && S && void 0 !== n && (console.error("Interpolating a className from css`` is not recommended and will cause problems with composition.\nInterpolating a className from css`` will be completely unsupported in a future major version of Emotion"), S = !1), void 0 === n || b ? e : n;
  }
}

var D,
    Q,
    O = /label:\s*([^\s;\n{]+)\s*;/g;
"production" !== process.env.NODE_ENV && (D = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//);

var U = function U(c, g, e) {
  if (1 === c.length && "object" == typeof c[0] && null !== c[0] && void 0 !== c[0].styles) return c[0];
  var b = !0,
      I = "";
  Q = void 0;
  var l,
      t = c[0];
  null == t || void 0 === t.raw ? (b = !1, I += j(e, g, t, !1)) : ("production" !== process.env.NODE_ENV && void 0 === t[0] && console.error(h), I += t[0]);

  for (var i = 1; i < c.length; i++) {
    I += j(e, g, c[i], 46 === I.charCodeAt(I.length - 1)), b && ("production" !== process.env.NODE_ENV && void 0 === t[i] && console.error(h), I += t[i]);
  }

  "production" !== process.env.NODE_ENV && (I = I.replace(D, function (c) {
    return l = c, "";
  })), O.lastIndex = 0;

  for (var n, C = ""; null !== (n = O.exec(I));) {
    C += "-" + n[1];
  }

  var o = function (c) {
    for (var g, e = c.length, b = e ^ e, I = 0; e >= 4;) {
      g = 1540483477 * (65535 & (g = 255 & c.charCodeAt(I) | (255 & c.charCodeAt(++I)) << 8 | (255 & c.charCodeAt(++I)) << 16 | (255 & c.charCodeAt(++I)) << 24)) + ((1540483477 * (g >>> 16) & 65535) << 16), b = 1540483477 * (65535 & b) + ((1540483477 * (b >>> 16) & 65535) << 16) ^ (g = 1540483477 * (65535 & (g ^= g >>> 24)) + ((1540483477 * (g >>> 16) & 65535) << 16)), e -= 4, ++I;
    }

    switch (e) {
      case 3:
        b ^= (255 & c.charCodeAt(I + 2)) << 16;

      case 2:
        b ^= (255 & c.charCodeAt(I + 1)) << 8;

      case 1:
        b = 1540483477 * (65535 & (b ^= 255 & c.charCodeAt(I))) + ((1540483477 * (b >>> 16) & 65535) << 16);
    }

    return b = 1540483477 * (65535 & (b ^= b >>> 13)) + ((1540483477 * (b >>> 16) & 65535) << 16), ((b ^= b >>> 15) >>> 0).toString(36);
  }(I) + C;

  return "production" !== process.env.NODE_ENV ? {
    name: o,
    styles: I,
    map: l,
    next: Q
  } : {
    name: o,
    styles: I,
    next: Q
  };
},
    P = g("undefined" != typeof HTMLElement ? function (c) {
  void 0 === c && (c = {});
  var g,
      e = c.key || "css";
  void 0 !== c.prefix && (g = {
    prefix: c.prefix
  });
  var b = new d(g);
  if ("production" !== process.env.NODE_ENV && /[^a-z-]/.test(e)) throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + e + '" was passed');
  var I,
      l = {};
  I = c.container || document.head;
  var t,
      i = document.querySelectorAll("style[data-emotion-" + e + "]");

  if (Array.prototype.forEach.call(i, function (c) {
    c.getAttribute("data-emotion-" + e).split(" ").forEach(function (c) {
      l[c] = !0;
    }), c.parentNode !== I && I.appendChild(c);
  }), b.use(c.stylisPlugins)(V), t = function t(c, g, e, I) {
    var l = g.name;

    if (W.current = e, "production" !== process.env.NODE_ENV && void 0 !== g.map) {
      var t = g.map;
      W.current = {
        insert: function insert(c) {
          e.insert(c + t);
        }
      };
    }

    b(c, g.styles), I && (o.inserted[l] = !0);
  }, "production" !== process.env.NODE_ENV) {
    var n = /\/\*/g,
        C = /\*\//g;
    b.use(function (c, g) {
      switch (c) {
        case -1:
          for (; n.test(g);) {
            if (C.lastIndex = n.lastIndex, !C.test(g)) throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
            n.lastIndex = C.lastIndex;
          }

          n.lastIndex = 0;
      }
    }), b.use(function (c, g, e) {
      switch (c) {
        case -1:
          var b = g.match(/(:first|:nth|:nth-last)-child/g);
          b && !0 !== o.compat && b.forEach(function (c) {
            var e = new RegExp(c + ".*\\/\\* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason \\*\\/").test(g);
            c && !e && console.error('The pseudo class "' + c + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + c.split("-child")[0] + '-of-type".');
          });
      }
    });
  }

  var o = {
    key: e,
    sheet: new m({
      key: e,
      container: I,
      nonce: c.nonce,
      speedy: c.speedy
    }),
    nonce: c.nonce,
    inserted: l,
    registered: {},
    insert: t
  };
  return o;
}() : null),
    E = g({}),
    T = function T(c) {
  return e(function (g, e) {
    return b(P.Consumer, null, function (b) {
      return c(g, b, e);
    });
  });
},
    K = Object.prototype.hasOwnProperty,
    M = function M(c, g, e, I) {
  var l = g.__EMOTION_TYPE_PLEASE_DO_NOT_USE__,
      t = [],
      i = "",
      n = null === e ? g.css : g.css(e);
  "string" == typeof n && void 0 !== c.registered[n] && (n = c.registered[n]), t.push(n), void 0 !== g.className && (i = v(c.registered, t, g.className));
  var C = U(t);

  if ("production" !== process.env.NODE_ENV && -1 === C.name.indexOf("-")) {
    var o = g.__EMOTION_LABEL_PLEASE_DO_NOT_USE__;
    o && (C = U([C, "label:" + o + ";"]));
  }

  X(c, C, "string" == typeof l), i += c.key + "-" + C.name;
  var r = {};

  for (var A in g) {
    !K.call(g, A) || "css" === A || "__EMOTION_TYPE_PLEASE_DO_NOT_USE__" === A || "production" !== process.env.NODE_ENV && "__EMOTION_LABEL_PLEASE_DO_NOT_USE__" === A || (r[A] = g[A]);
  }

  return r.ref = I, r.className = i, b(l, r);
},
    _ = T(function (c, g, e) {
  return "function" == typeof c.css ? b(E.Consumer, null, function (b) {
    return M(g, c, b, e);
  }) : M(g, c, null, e);
});

"production" !== process.env.NODE_ENV && (_.displayName = "EmotionCssPropInternal");

var q = function c(g) {
  for (var e = g.length, b = 0, I = ""; b < e; b++) {
    var l = g[b];

    if (null != l) {
      var t = void 0;

      switch (typeof l) {
        case "boolean":
          break;

        case "object":
          if (Array.isArray(l)) t = c(l);else for (var i in t = "", l) {
            l[i] && i && (t && (t += " "), t += i);
          }
          break;

        default:
          t = l;
      }

      t && (I && (I += " "), I += t);
    }
  }

  return I;
};

function $(c, g, e) {
  var b = [],
      I = v(c, b, e);
  return b.length < 2 ? e : I + g(b);
}

T(function (c, g) {
  return b(E.Consumer, null, function (e) {
    var b = !1,
        I = function I() {
      if (b && "production" !== process.env.NODE_ENV) throw new Error("css can only be used during render");

      for (var c = arguments.length, e = new Array(c), I = 0; I < c; I++) {
        e[I] = arguments[I];
      }

      var l = U(e, g.registered);
      return X(g, l, !1), g.key + "-" + l.name;
    },
        l = c.children({
      css: I,
      cx: function cx() {
        if (b && "production" !== process.env.NODE_ENV) throw new Error("cx can only be used during render");

        for (var c = arguments.length, e = new Array(c), l = 0; l < c; l++) {
          e[l] = arguments[l];
        }

        return $(g.registered, I, q(e));
      },
      theme: e
    });

    return b = !0, l;
  });
});

var cc = t,
    gc = function gc(c) {
  return "theme" !== c && "innerRef" !== c;
},
    ec = function ec(c) {
  return "string" == typeof c && c.charCodeAt(0) > 96 ? cc : gc;
};

function bc(c, g) {
  var e = Object.keys(c);

  if (Object.getOwnPropertySymbols) {
    var b = Object.getOwnPropertySymbols(c);
    g && (b = b.filter(function (g) {
      return Object.getOwnPropertyDescriptor(c, g).enumerable;
    })), e.push.apply(e, b);
  }

  return e;
}

function Ic(c) {
  for (var g = 1; g < arguments.length; g++) {
    var e = null != arguments[g] ? arguments[g] : {};
    g % 2 ? bc(e, !0).forEach(function (g) {
      s(c, g, e[g]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(c, Object.getOwnPropertyDescriptors(e)) : bc(e).forEach(function (g) {
      Object.defineProperty(c, g, Object.getOwnPropertyDescriptor(e, g));
    });
  }

  return c;
}

var lc = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences",
    tc = function c(g, e) {
  if ("production" !== process.env.NODE_ENV && void 0 === g) throw new Error("You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.");
  var I, l, t;
  void 0 !== e && (I = e.label, t = e.target, l = g.__emotion_forwardProp && e.shouldForwardProp ? function (c) {
    return g.__emotion_forwardProp(c) && e.shouldForwardProp(c);
  } : e.shouldForwardProp);
  var i = g.__emotion_real === g,
      n = i && g.__emotion_base || g;
  "function" != typeof l && i && (l = g.__emotion_forwardProp);
  var C = l || ec(n),
      o = !C("as");
  return function () {
    var r = arguments,
        A = i && void 0 !== g.__emotion_styles ? g.__emotion_styles.slice(0) : [];
    if (void 0 !== I && A.push("label:" + I + ";"), null == r[0] || void 0 === r[0].raw) A.push.apply(A, r);else {
      "production" !== process.env.NODE_ENV && void 0 === r[0][0] && console.error(lc), A.push(r[0][0]);

      for (var G = r.length, u = 1; u < G; u++) {
        "production" !== process.env.NODE_ENV && void 0 === r[0][u] && console.error(lc), A.push(r[u], r[0][u]);
      }
    }
    var a = T(function (c, g, e) {
      return b(E.Consumer, null, function (i) {
        var r = o && c.as || n,
            G = "",
            u = [],
            a = c;

        if (null == c.theme) {
          for (var Z in a = {}, c) {
            a[Z] = c[Z];
          }

          a.theme = i;
        }

        "string" == typeof c.className && (G += v(g.registered, u, c.className));
        var s = U(A.concat(u), g.registered, a);
        X(g, s, "string" == typeof r), G += g.key + "-" + s.name, void 0 !== t && (G += " " + t);
        var m = o && void 0 === l ? ec(r) : C,
            d = {};

        for (var B in c) {
          o && "as" === B || m(B) && (d[B] = c[B]);
        }

        return d.className = G, d.ref = e || c.innerRef, "production" !== process.env.NODE_ENV && c.innerRef && console.error("`innerRef` is deprecated and will be removed in a future major version of Emotion, please use the `ref` prop instead" + (void 0 === I ? "" : " in the usage of `" + I + "`")), b(r, d);
      });
    });
    return a.displayName = void 0 !== I ? I : "Styled(" + ("string" == typeof n ? n : n.displayName || n.name || "Component") + ")", a.defaultProps = g.defaultProps, a.__emotion_real = a, a.__emotion_base = n, a.__emotion_styles = A, a.__emotion_forwardProp = l, Object.defineProperty(a, "toString", {
      value: function value() {
        return void 0 === t && "production" !== process.env.NODE_ENV ? "NO_COMPONENT_SELECTOR" : "." + t;
      }
    }), a.withComponent = function (g, b) {
      return c(g, void 0 !== b ? Ic({}, e || {}, {}, b) : e).apply(void 0, A);
    }, a;
  };
},
    ic = Z({}, r.light, {
  popover: {
    backgroundColor: r.light.colors.white,
    borderColor: r.light.colors.gray1
  }
});

function nc(c) {
  var g = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
  };
  return c.replace(/left|right|bottom|top/g, function (c) {
    return g[c];
  });
}

var Cc = tc("div", {
  target: "e1oyuzn00",
  label: "ArrowBorder"
})("production" === process.env.NODE_ENV ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
    oc = tc(e(function (c, g) {
  return b("div", Z({}, c, {
    ref: g
  }), b(Cc, c));
}), {
  target: "e1oyuzn01",
  label: "Arrow"
})("display:block;position:absolute;width:0;height:0;border-style:solid;border-color:", function (c) {
  return c.theme.popover.borderColor;
}, ";" + ("production" === process.env.NODE_ENV ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
oc.defaultProps = {
  theme: ic
};
var rc = tc("div", {
  shouldForwardProp: function shouldForwardProp(c) {
    return !["open", "close", "toggle"].includes(c) && t(c);
  },
  target: "e1oyuzn02",
  label: "Container"
})("background-color:", function (c) {
  return c.theme.popover.backgroundColor;
}, ";color:", function (c) {
  return c.theme.primary;
}, ";border:1px solid ", function (c) {
  return c.theme.popover.borderColor;
}, ";border-radius:2px;padding:", function (c) {
  return c.theme.sizes.small;
}, ";filter:drop-shadow( 0 2px 2px ", function (c) {
  return A(c.theme.colors.black).alpha(.2).string();
}, " );z-index:1;", function (g) {
  return c("margin-", nc(g.placement), ":", g.arrowSize, "px;", oc, "{border-width:", g.arrowSize, "px;", nc(g.placement), ":-", g.arrowSize, "px;border-", nc(g.placement), "-width:0;border-color:transparent;border-", g.placement, "-color:", g.theme.popover.backgroundColor, ";left:", g.arrowProps.style.left, "px;top:", g.arrowProps.style.top, "px;}", Cc, "{border-width:", g.arrowSize + 1, "px;border-", g.placement, "-color:", g.theme.popover.borderColor, ";left:-", g.arrowSize + 1, "px;top:-", g.arrowSize + 1, "px;transform:", ["left", "right"].includes(g.placement) ? "translateX(" + ("left" === g.placement ? 1.5 : -1.5) + "px)" : "translateY(" + ("top" === g.placement ? 1.5 : -1.5) + "px)", ";z-index:-1;}label:Container;" + ("production" === process.env.NODE_ENV ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQTRFZ0IiLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvcHlyaWdodCAoYykgUXVpZCwgSW5jLlxuICpcbiAqIFRoaXMgc291cmNlIGNvZGUgaXMgbGljZW5zZWQgdW5kZXIgdGhlIE1JVCBsaWNlbnNlIGZvdW5kIGluIHRoZVxuICogTElDRU5TRSBmaWxlIGluIHRoZSByb290IGRpcmVjdG9yeSBvZiB0aGlzIHNvdXJjZSB0cmVlLlxuICovXG4vLyBAZmxvd1xuaW1wb3J0ICogYXMgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IHtcbiAgTWFuYWdlcixcbiAgUmVmZXJlbmNlLFxuICBQb3BwZXIsXG4gIHR5cGUgUG9wcGVyQXJyb3dQcm9wcyxcbn0gZnJvbSAncmVhY3QtcG9wcGVyJztcbmltcG9ydCB7IHR5cGUgUGxhY2VtZW50LCB0eXBlIE1vZGlmaWVycyB9IGZyb20gJ3BvcHBlci5qcyc7XG5pbXBvcnQgeyB1c2VEZWJvdW5jZWRDYWxsYmFjayB9IGZyb20gJ3VzZS1kZWJvdW5jZSc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZC9tYWNybyc7XG5pbXBvcnQgY3NzIGZyb20gJ0BlbW90aW9uL2Nzcy9tYWNybyc7XG5pbXBvcnQgaXNQcm9wVmFsaWQgZnJvbSAnQGVtb3Rpb24vaXMtcHJvcC12YWxpZCc7XG5pbXBvcnQgeyB0aGVtZXMgfSBmcm9tICdAcXVpZC90aGVtZSc7XG5pbXBvcnQgQ29sb3IgZnJvbSAnY29sb3InO1xuaW1wb3J0IE1vdXNlT3V0c2lkZSBmcm9tICdAcXVpZC9yZWFjdC1tb3VzZS1vdXRzaWRlJztcbmltcG9ydCBtZXJnZVJlZnMgZnJvbSAnQHF1aWQvbWVyZ2UtcmVmcyc7XG5pbXBvcnQgdXNlQ29udHJvbGxlZFN0YXRlIGZyb20gJ0BxdWlkL3JlYWN0LXVzZS1jb250cm9sbGVkLXN0YXRlJztcblxuY29uc3QgdGhlbWUgPSB7XG4gIC4uLnRoZW1lcy5saWdodCxcbiAgcG9wb3Zlcjoge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWVzLmxpZ2h0LmNvbG9ycy53aGl0ZSxcbiAgICBib3JkZXJDb2xvcjogdGhlbWVzLmxpZ2h0LmNvbG9ycy5ncmF5MSxcbiAgfSxcbn07XG5cbmZ1bmN0aW9uIGdldE9wcG9zaXRlUGxhY2VtZW50KHBsYWNlbWVudCkge1xuICBjb25zdCBoYXNoID0geyBsZWZ0OiAncmlnaHQnLCByaWdodDogJ2xlZnQnLCBib3R0b206ICd0b3AnLCB0b3A6ICdib3R0b20nIH07XG4gIHJldHVybiBwbGFjZW1lbnQucmVwbGFjZSgvbGVmdHxyaWdodHxib3R0b218dG9wL2csIG1hdGNoZWQgPT4gaGFzaFttYXRjaGVkXSk7XG59XG5cbmNvbnN0IEFycm93Qm9yZGVyID0gc3R5bGVkLmRpdmBgO1xuXG5jb25zdCBBcnJvdyA9IHN0eWxlZChcbiAgUmVhY3QuZm9yd2FyZFJlZigocHJvcHMsIHJlZikgPT4gKFxuICAgIDxkaXYgey4uLnByb3BzfSByZWY9e3JlZn0+XG4gICAgICA8QXJyb3dCb3JkZXIgey4uLnByb3BzfSAvPlxuICAgIDwvZGl2PlxuICApKVxuKWBcbiAgZGlzcGxheTogYmxvY2s7XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgd2lkdGg6IDA7XG4gIGhlaWdodDogMDtcbiAgYm9yZGVyLXN0eWxlOiBzb2xpZDtcbiAgYm9yZGVyLWNvbG9yOiAke3Byb3BzID0+IHByb3BzLnRoZW1lLnBvcG92ZXIuYm9yZGVyQ29sb3J9O1xuYDtcbkFycm93LmRlZmF1bHRQcm9wcyA9IHtcbiAgdGhlbWUsXG59O1xuXG5jb25zdCBDb250YWluZXIgPSBzdHlsZWQoJ2RpdicsIHtcbiAgc2hvdWxkRm9yd2FyZFByb3A6IHByb3AgPT5cbiAgICAhWydvcGVuJywgJ2Nsb3NlJywgJ3RvZ2dsZSddLmluY2x1ZGVzKHByb3ApICYmIGlzUHJvcFZhbGlkKHByb3ApLFxufSlgXG4gIGJhY2tncm91bmQtY29sb3I6ICR7cHJvcHMgPT4gcHJvcHMudGhlbWUucG9wb3Zlci5iYWNrZ3JvdW5kQ29sb3J9O1xuICBjb2xvcjogJHtwcm9wcyA9PiBwcm9wcy50aGVtZS5wcmltYXJ5fTtcbiAgYm9yZGVyOiAxcHggc29saWQgJHtwcm9wcyA9PiBwcm9wcy50aGVtZS5wb3BvdmVyLmJvcmRlckNvbG9yfTtcbiAgYm9yZGVyLXJhZGl1czogMnB4O1xuICBwYWRkaW5nOiAke3Byb3BzID0+IHByb3BzLnRoZW1lLnNpemVzLnNtYWxsfTtcbiAgZmlsdGVyOiBkcm9wLXNoYWRvdyhcbiAgICAwIDJweCAycHhcbiAgICAgICR7cHJvcHMgPT5cbiAgICAgICAgQ29sb3IocHJvcHMudGhlbWUuY29sb3JzLmJsYWNrKVxuICAgICAgICAgIC5hbHBoYSgwLjIpXG4gICAgICAgICAgLnN0cmluZygpfVxuICApO1xuICB6LWluZGV4OiAxO1xuXG4gICR7cHJvcHMgPT4gY3NzYFxuICAgIG1hcmdpbi0ke2dldE9wcG9zaXRlUGxhY2VtZW50KHByb3BzLnBsYWNlbWVudCl9OiAke3Byb3BzLmFycm93U2l6ZX1weDtcblxuICAgICR7QXJyb3d9IHtcbiAgICAgIGJvcmRlci13aWR0aDogJHtwcm9wcy5hcnJvd1NpemV9cHg7XG4gICAgICAke2dldE9wcG9zaXRlUGxhY2VtZW50KHByb3BzLnBsYWNlbWVudCl9OiAtJHtwcm9wcy5hcnJvd1NpemV9cHg7XG4gICAgICBib3JkZXItJHtnZXRPcHBvc2l0ZVBsYWNlbWVudChwcm9wcy5wbGFjZW1lbnQpfS13aWR0aDogMDtcbiAgICAgIGJvcmRlci1jb2xvcjogdHJhbnNwYXJlbnQ7XG4gICAgICBib3JkZXItJHtwcm9wcy5wbGFjZW1lbnR9LWNvbG9yOiAke3Byb3BzLnRoZW1lLnBvcG92ZXIuYmFja2dyb3VuZENvbG9yfTtcbiAgICAgIGxlZnQ6ICR7cHJvcHMuYXJyb3dQcm9wcy5zdHlsZS5sZWZ0fXB4O1xuICAgICAgdG9wOiAke3Byb3BzLmFycm93UHJvcHMuc3R5bGUudG9wfXB4O1xuICAgIH1cblxuICAgICR7QXJyb3dCb3JkZXJ9IHtcbiAgICAgIGJvcmRlci13aWR0aDogJHtwcm9wcy5hcnJvd1NpemUgKyAxfXB4O1xuICAgICAgYm9yZGVyLSR7cHJvcHMucGxhY2VtZW50fS1jb2xvcjogJHtwcm9wcy50aGVtZS5wb3BvdmVyLmJvcmRlckNvbG9yfTtcbiAgICAgIGxlZnQ6IC0ke3Byb3BzLmFycm93U2l6ZSArIDF9cHg7XG4gICAgICB0b3A6IC0ke3Byb3BzLmFycm93U2l6ZSArIDF9cHg7XG4gICAgICB0cmFuc2Zvcm06ICR7XG4gICAgICAgIFsnbGVmdCcsICdyaWdodCddLmluY2x1ZGVzKHByb3BzLnBsYWNlbWVudClcbiAgICAgICAgICA/IGB0cmFuc2xhdGVYKCR7cHJvcHMucGxhY2VtZW50ID09PSAnbGVmdCcgPyAxLjUgOiAtMS41fXB4KWBcbiAgICAgICAgICA6IGB0cmFuc2xhdGVZKCR7cHJvcHMucGxhY2VtZW50ID09PSAndG9wJyA/IDEuNSA6IC0xLjV9cHgpYFxuICAgICAgfTtcbiAgICAgIHotaW5kZXg6IC0xO1xuICAgIH1cbiAgYH1cbmA7XG5Db250YWluZXIuZGVmYXVsdFByb3BzID0ge1xuICBhcnJvd1NpemU6IDYsXG4gIHBsYWNlbWVudDogJ2JvdHRvbScsXG4gIGFycm93UHJvcHM6IHsgc3R5bGU6IHsgdG9wOiAwLCBsZWZ0OiAwIH0gfSxcbiAgdGhlbWUsXG59O1xuXG5leHBvcnQgdHlwZSBIZWxwZXJzID0ge1xuICB0b2dnbGU6ICgpID0+IHZvaWQsXG4gIG9wZW46ICgpID0+IHZvaWQsXG4gIGNsb3NlOiAoKSA9PiB2b2lkLFxufTtcbnR5cGUgUmVuZGVyUG9wb3ZlclByb3BzID0ge1xuICByZWY6IFJlYWN0LkVsZW1lbnRSZWY8YW55PixcbiAgc3R5bGU6ICRTaGFwZTxDU1NTdHlsZURlY2xhcmF0aW9uPixcbiAgcGxhY2VtZW50OiBQbGFjZW1lbnQsXG4gIGFycm93UHJvcHM6IFBvcHBlckFycm93UHJvcHMsXG59ICYgSGVscGVycztcblxudHlwZSBQcm9wcyA9IHtcbiAgb3Blbj86IGJvb2xlYW4sXG4gIG9uVG9nZ2xlPzogYm9vbGVhbiA9PiB2b2lkLFxuICBkZWZhdWx0T3Blbj86IGJvb2xlYW4sXG4gIHJlbmRlclBvcG92ZXI6IFJlbmRlclBvcG92ZXJQcm9wcyA9PiBSZWFjdC5Ob2RlLFxuICBwbGFjZW1lbnQ/OiBQbGFjZW1lbnQsXG4gIG1vZGlmaWVycz86IE1vZGlmaWVycyxcbiAgZXZlbnRzRW5hYmxlZD86IGJvb2xlYW4sXG4gIHBvc2l0aW9uRml4ZWQ/OiBib29sZWFuLFxuICBtb3VzZU1vdmVCZWhhdmlvcj86IGJvb2xlYW4sXG4gIG9wZW5EZWxheT86IG51bWJlcixcbiAgY2xvc2VEZWxheT86IG51bWJlcixcbiAgY2hpbGRyZW46ICh7IHJlZjogUmVhY3QuRWxlbWVudFJlZjxhbnk+IH0gJiBIZWxwZXJzKSA9PiBSZWFjdC5Ob2RlLFxufTtcblxuY29uc3QgUG9wb3ZlciA9ICh7XG4gIGRlZmF1bHRPcGVuLFxuICBvcGVuLFxuICBvblRvZ2dsZSxcbiAgcmVuZGVyUG9wb3ZlcixcbiAgcGxhY2VtZW50ID0gJ2JvdHRvbScsXG4gIG1vZGlmaWVycyxcbiAgZXZlbnRzRW5hYmxlZCA9IHRydWUsXG4gIHBvc2l0aW9uRml4ZWQgPSBmYWxzZSxcbiAgbW91c2VNb3ZlQmVoYXZpb3IgPSBmYWxzZSxcbiAgb3BlbkRlbGF5ID0gMCxcbiAgY2xvc2VEZWxheSA9IDAsXG4gIGNoaWxkcmVuLFxufTogUHJvcHMpID0+IHtcbiAgY29uc3QgcmVmZXJlbmNlUmVmID0gUmVhY3QudXNlUmVmKCk7XG4gIGNvbnN0IHBvcHBlclJlZiA9IFJlYWN0LnVzZVJlZigpO1xuXG4gIGNvbnN0IFtpc09wZW4sIHNldE9wZW5dID0gdXNlQ29udHJvbGxlZFN0YXRlKGRlZmF1bHRPcGVuLCBvcGVuLCBvblRvZ2dsZSk7XG5cbiAgY29uc3QgW2RlYm91bmNlZE9wZW4sIGNhbmNlbE9wZW5dID0gdXNlRGVib3VuY2VkQ2FsbGJhY2soXG4gICAgKCkgPT4gc2V0T3Blbih0cnVlKSxcbiAgICBvcGVuRGVsYXlcbiAgKTtcbiAgY29uc3QgW2RlYm91bmNlZENsb3NlLCBjYW5jZWxDbG9zZV0gPSB1c2VEZWJvdW5jZWRDYWxsYmFjayhcbiAgICAoKSA9PiBzZXRPcGVuKGZhbHNlKSxcbiAgICBjbG9zZURlbGF5XG4gICk7XG5cbiAgLy8gV2hlbiBhIGNhbGxiYWNrIGlzIGZpcmVkLCB3ZSBjYW5jZWwgYW55IGluZmxpZ2h0IGNhbGwgdG8gbGVhdmUgdGhlIG5ldyBvbmUgYWxvbmVcbiAgY29uc3Qgb3BlbkZuID0gUmVhY3QudXNlQ2FsbGJhY2soXG4gICAgKCkgPT4gdm9pZCAoY2FuY2VsQ2xvc2UoKSwgZGVib3VuY2VkT3BlbigpKSxcbiAgICBbY2FuY2VsQ2xvc2UsIGRlYm91bmNlZE9wZW5dXG4gICk7XG4gIGNvbnN0IGNsb3NlRm4gPSBSZWFjdC51c2VDYWxsYmFjayhcbiAgICAoKSA9PiB2b2lkIChjYW5jZWxPcGVuKCksIGRlYm91bmNlZENsb3NlKCkpLFxuICAgIFtjYW5jZWxPcGVuLCBkZWJvdW5jZWRDbG9zZV1cbiAgKTtcbiAgY29uc3QgdG9nZ2xlRm4gPSBSZWFjdC51c2VDYWxsYmFjaygoKSA9PiAoaXNPcGVuID8gY2xvc2VGbigpIDogb3BlbkZuKCkpLCBbXG4gICAgaXNPcGVuLFxuICAgIGNsb3NlRm4sXG4gICAgb3BlbkZuLFxuICBdKTtcblxuICBjb25zdCBoZWxwZXJzID0ge1xuICAgIHRvZ2dsZTogdG9nZ2xlRm4sXG4gICAgb3Blbjogb3BlbkZuLFxuICAgIGNsb3NlOiBjbG9zZUZuLFxuICB9O1xuXG4gIHJldHVybiAoXG4gICAgPE1vdXNlT3V0c2lkZVxuICAgICAgcmVmcz17W3JlZmVyZW5jZVJlZiwgcG9wcGVyUmVmXX1cbiAgICAgIG9uQ2xpY2tPdXRzaWRlPXtjbG9zZUZufVxuICAgICAgb25Nb3ZlT3V0c2lkZT17bW91c2VNb3ZlQmVoYXZpb3IgPyBjbG9zZUZuIDogdW5kZWZpbmVkfVxuICAgID5cbiAgICAgIHsoKSA9PiAoXG4gICAgICAgIDxNYW5hZ2VyPlxuICAgICAgICAgIDxSZWZlcmVuY2U+XG4gICAgICAgICAgICB7KHsgcmVmIH0pID0+XG4gICAgICAgICAgICAgIGNoaWxkcmVuKHtcbiAgICAgICAgICAgICAgICAuLi5oZWxwZXJzLFxuICAgICAgICAgICAgICAgIHJlZjogbWVyZ2VSZWZzKHJlZiwgcmVmZXJlbmNlUmVmKSxcbiAgICAgICAgICAgICAgfSlcbiAgICAgICAgICAgIH1cbiAgICAgICAgICA8L1JlZmVyZW5jZT5cbiAgICAgICAgICB7aXNPcGVuICYmIChcbiAgICAgICAgICAgIDxQb3BwZXJcbiAgICAgICAgICAgICAgcGxhY2VtZW50PXtwbGFjZW1lbnR9XG4gICAgICAgICAgICAgIG1vZGlmaWVycz17bW9kaWZpZXJzfVxuICAgICAgICAgICAgICBldmVudHNFbmFibGVkPXtldmVudHNFbmFibGVkfVxuICAgICAgICAgICAgICBwb3NpdGlvbkZpeGVkPXtwb3NpdGlvbkZpeGVkfVxuICAgICAgICAgICAgPlxuICAgICAgICAgICAgICB7KHsgcmVmLCAuLi5wb3BwZXJQcm9wcyB9KSA9PlxuICAgICAgICAgICAgICAgIHJlbmRlclBvcG92ZXIoe1xuICAgICAgICAgICAgICAgICAgLi4ucG9wcGVyUHJvcHMsXG4gICAgICAgICAgICAgICAgICAuLi5oZWxwZXJzLFxuICAgICAgICAgICAgICAgICAgcmVmOiBtZXJnZVJlZnMocmVmLCBwb3BwZXJSZWYpLFxuICAgICAgICAgICAgICAgIH0pXG4gICAgICAgICAgICAgIH1cbiAgICAgICAgICAgIDwvUG9wcGVyPlxuICAgICAgICAgICl9XG4gICAgICAgIDwvTWFuYWdlcj5cbiAgICAgICl9XG4gICAgPC9Nb3VzZU91dHNpZGU+XG4gICk7XG59O1xuXG5leHBvcnQgeyBQb3BvdmVyLCBDb250YWluZXIsIEFycm93IH07XG4iXX0= */"));
}, "production" === process.env.NODE_ENV ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
rc.defaultProps = {
  arrowSize: 6,
  placement: "bottom",
  arrowProps: {
    style: {
      top: 0,
      left: 0
    }
  },
  theme: ic
};

var Ac = function Ac(c) {
  var g = c.defaultOpen,
      e = c.open,
      t = c.onToggle,
      r = c.renderPopover,
      A = c.placement,
      s = void 0 === A ? "bottom" : A,
      m = c.modifiers,
      d = c.eventsEnabled,
      B = void 0 === d || d,
      W = c.positionFixed,
      V = void 0 !== W && W,
      v = c.mouseMoveBehavior,
      y = void 0 !== v && v,
      x = c.openDelay,
      X = void 0 === x ? 0 : x,
      p = c.closeDelay,
      h = void 0 === p ? 0 : p,
      J = c.children,
      w = I(),
      Y = I(),
      H = a(g, e, t),
      N = H[0],
      f = H[1],
      R = o(function () {
    return f(!0);
  }, X),
      k = R[0],
      F = R[1],
      z = o(function () {
    return f(!1);
  }, h),
      L = z[0],
      S = z[1],
      j = l(function () {
    return S(), void k();
  }, [S, k]),
      D = l(function () {
    return F(), void L();
  }, [F, L]),
      Q = {
    toggle: l(function () {
      return N ? D() : j();
    }, [N, D, j]),
    open: j,
    close: D
  };
  return b(G, {
    refs: [w, Y],
    onClickOutside: D,
    onMoveOutside: y ? D : void 0
  }, function () {
    return b(i, null, b(n, null, function (c) {
      return J(Z({}, Q, {
        ref: u(c.ref, w)
      }));
    }), N && b(C, {
      placement: s,
      modifiers: m,
      eventsEnabled: B,
      positionFixed: V
    }, function (c) {
      var g = c.ref,
          e = function (c, g) {
        if (null == c) return {};
        var e,
            b,
            I = {},
            l = Object.keys(c);

        for (b = 0; b < l.length; b++) {
          g.indexOf(e = l[b]) >= 0 || (I[e] = c[e]);
        }

        return I;
      }(c, ["ref"]);

      return r(Z({}, e, {}, Q, {
        ref: u(g, Y)
      }));
    }));
  });
};

export { oc as Arrow, rc as Container, Ac as Popover };